// extracted by mini-css-extract-plugin
export default {"imageWrapper":"kG-z","hovered":"lG-z","hoverImage":"mG-z","mainImage":"nG-z","imageNoBackground":"oG-z","fullSizeImage":"pG-z"};